/**
 * Automatically import all brand configuration files
 * Uses webpack's require.context to dynamically load all .config.js files
 */
const brandConfigContext = require.context('./', false, /\.config\.js$/);

/**
 * Brand configuration registry
 * Automatically populated from all .config.js files in this directory
 */
const brandConfig = {};

brandConfigContext.keys().forEach((fileName) => {
  // Extract brand name from filename (e.g., './prosaris.config.js' -> 'prosaris')
  const brandName = fileName.replace(/^\.\//, '').replace(/\.config\.js$/, '');
  // Import the default export from each config file
  const config = brandConfigContext(fileName).default;

  brandConfig[brandName] = config;
});

// Set prosaris as the default brand
const defaultBrand = brandConfig.prosaris;

/**
 * Get the brand configuration key for a given hostname
 * Dynamically builds URL mappings from each brand's urls array
 * @param {string} hostname - The hostname to lookup
 * @returns {string} - The brand configuration key (null if no match found)
 */
export const getConfigKeyForHostname = (hostname) => {
  for (const [configKey, config] of Object.entries(brandConfig)) {
    if (config.urls && config.urls.includes(hostname)) {
      return configKey;
    }
  }
  return null;
};

/**
 * Get the brand configuration for a given hostname
 * @param {string} hostname - The hostname to lookup
 * @returns {Object} - The brand configuration object (defaults to prosaris)
 */
export const getBrandConfig = (hostname) => {
  const configKey = getConfigKeyForHostname(hostname);
  return configKey ? brandConfig[configKey] : defaultBrand;
};

export { brandConfig };
